import { SET_SECONDARY_PARAMETER } from './types';

export const setSecondaryParameter = secondaryParameter => ({
  type: SET_SECONDARY_PARAMETER, secondaryParameter
});
